var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41414",
    "data-name": "Group 41414",
    transform: "translate(12422 17260)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15361",
    "data-name": "Rectangle 15361",
    width: 24,
    height: 24,
    transform: "translate(-12422 -17260)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bin_x2F_delete_layer_1_",
    transform: "translate(-12418.897 -17258.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36968",
    "data-name": "Path 36968",
    d: "M73.8,100a1.78,1.78,0,0,0-1.78,1.78v13.881a1.78,1.78,0,0,1-1.78,1.78H59.559a1.78,1.78,0,0,1-1.78-1.78V101.78A1.78,1.78,0,0,0,56,100",
    transform: "translate(-56 -96.441)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2718",
    "data-name": "Line 2718",
    x2: 17.797,
    transform: "translate(0 3.559)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2719",
    "data-name": "Line 2719",
    y2: 10.322,
    transform: "translate(5.339 7.119)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2720",
    "data-name": "Line 2720",
    y2: 10.322,
    transform: "translate(8.898 7.119)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2721",
    "data-name": "Line 2721",
    y2: 10.322,
    transform: "translate(12.458 7.119)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36969",
    "data-name": "Path 36969",
    d: "M183.119,23.559H176V21.78A1.78,1.78,0,0,1,177.78,20h3.559a1.78,1.78,0,0,1,1.78,1.78Z",
    transform: "translate(-170.661 -20)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.76c0eacf21219435f3a86e188b190e78.svg";
export { ForwardRef as ReactComponent };